import "angular:locale/data:en";
import "zone.js";
import "./projects/app/src/polyfills.ts";
import "@angular/localize/init";(globalThis.$localize ??= {}).locale = "en";
